import { render, staticRenderFns } from "./FamilyTab.vue?vue&type=template&id=4a3ab77a&scoped=true"
import script from "./FamilyTab.vue?vue&type=script&lang=js"
export * from "./FamilyTab.vue?vue&type=script&lang=js"
import style0 from "./FamilyTab.vue?vue&type=style&index=0&id=4a3ab77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ab77a",
  null
  
)

export default component.exports